/**
 * Demo auth: create a JWT-like token that passes validateToken (jwtDecode) so
 * demo credentials can access the app without a backend.
 */
import { validateToken } from './tokenValidator';
import { getV2Token } from './v2AuthUtils';

const DEMO_USERNAME = 'demo';
const DEMO_PASSWORD = 'demo123';

export const DEMO_CREDENTIALS = { username: DEMO_USERNAME, password: DEMO_PASSWORD };

export function isDemoCredentials(username: string, password: string): boolean {
  const u = (username || '').trim().toLowerCase();
  const p = (password || '').trim();
  return (u === DEMO_USERNAME || u === 'demo@comply.now') && p === DEMO_PASSWORD;
}

/** Check if the current token is the demo user (by decoding and checking username). */
export function isDemoUser(token: string | null): boolean {
  if (!token) return false;
  const user = validateToken(token);
  return user?.username === DEMO_USERNAME;
}

/**
 * Build a minimal JWT that jwtDecode can read (payload only; no signature verification).
 * Payload must match TokenPayload in tokenValidator.
 */
export function createDemoToken(): string {
  const now = Math.floor(Date.now() / 1000);
  const payload = {
    id: 'demo-partner-1',
    username: DEMO_USERNAME,
    name: 'Demo Partner',
    title: 'Partner',
    group: 'Partner',
    groupName: 'Partner',
    email: 'demo@comply.now',
    permissions: '',
    exp: now + 86400 * 365, // 1 year
    iat: now,
  };
  const header = { alg: 'HS256', typ: 'JWT' };
  const b64url = (obj: object) =>
    btoa(JSON.stringify(obj))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  return `${b64url(header)}.${b64url(payload)}.demo`;
}

/** Get token from storage and return whether it's demo. */
export function isCurrentUserDemo(): boolean {
  return isDemoUser(getV2Token());
}
